// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".kp-body-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #e5e5e5;\n  height: 100%;\n  padding: 0 20px;\n}\n.kp-success-redirect {\n  height: 50%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  align-items: center;\n}\n", ""]);
// Exports
module.exports = exports;
